import React, { useState, useRef } from 'react';
import { ContentPopup } from 'components/ContentPopup.jsx';
import HoverTooltip from 'components/common/HoverTooltip';

/**
 * A clickable "Learn more" affordance shown next to the "Link to data source" link. Modelled on
 * show_drawing/ToolTip: a help icon wrapped in a HoverTooltip (a quick hover teaser) that, when
 * clicked, opens a ContentPopup that explains — and sells — what linking a price to a spreadsheet
 * does. A passive hover tooltip alone only pays off if the user happens to hover long enough; the
 * click is the deliberate action that surfaces the full pitch.
 */
const DataSourceLearnMore = () => {
  const [showInfo, setShowInfo] = useState(false);
  const popupRef = useRef();

  const openInfo = (event) => {
    event.preventDefault();
    if (typeof trackEvent === 'function') {
      trackEvent('data_source_learn_more_opened', {});
    }
    setShowInfo(true);
  };

  const infoContent = (
    <div className="data-source-learn-more" style={{ textAlign: 'left' }}>
      <h3>{t('quote_builder.data_source_learn_more_title')}</h3>
      <div dangerouslySetInnerHTML={{ __html: t('quote_builder.data_source_learn_more_body_html') }} />
    </div>
  );

  return (
    <span className="data-source-learn-more-trigger" style={{ marginLeft: '10px' }}>
      <HoverTooltip title={t('quote_builder.link_to_data_source_hint')}>
        <a href="#" onClick={openInfo}>
          <i className="zmdi zmdi-pin-help"></i> {t('quote_builder.learn_more')}
        </a>
      </HoverTooltip>
      {showInfo && (
        <ContentPopup
          myRef={popupRef}
          autoOpen={true}
          content={infoContent}
          cancelButton={false}
          beforeClose={() => setShowInfo(false)}
        />
      )}
    </span>
  );
};

export default DataSourceLearnMore;
